import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import Navbar from "../components/Navbar/Navbar";

const Content = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: row;
  height: 100vh;
  font-family: Open Sans;
`;

const Panel = styled.div`
  height: 100%;
`;

const Sidebar = styled(Panel)`
  background-color: #e4e7f5;
  width: 250px;
`;

const Rightbar = styled(Panel)`
  flex-grow: 5;
`;

const SidebarTitle = styled.div`
  font-size: 25px;
  color: #535ca5;
  margin-top: 180px;
  width: 100%;
  padding: 30px;
  font-weight: bold;
`;

const SidebarContentContainer = styled.div`
  width: 100%;
  padding: 30px;
`;

const SidebarContentSubtitle = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
`;

const GeneratorContent = styled.div`
  margin-top: 130px;
  width: 100%;
  padding: 50px;
  height: calc(100% - 130px);
  overflow: auto;
`;

const Card = styled.div`
  width: 248px;
  height: 176px;
  border-radius: 15px;
  border: 2px solid #848dd3;
  margin: 20px;
  display: inline-block;
  position: relative;
  cursor: pointer;
`;

const InnerNewCard = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #535ca5;
  text-align: center;
`;

const ItemCardContainer = styled(Card)`
  background-color: #e4e7f5;
`;

const generators = [
  "Blog Post",
  "SEO Metatag",
  "Google Ad",
  "Facebook Ad",
  "Product Description",
  "Taglines",
];

const NewCard = (props) => {
  return (
    <Card {...props}>
      <InnerNewCard>
        <div style={{ fontSize: 45 }}>+</div>
        <div>New Google Ad</div>
      </InnerNewCard>
    </Card>
  );
};

const ItemCard = () => {
  return (
    <ItemCardContainer>
      <InnerNewCard>Hello</InnerNewCard>
    </ItemCardContainer>
  );
};

const Templates = () => {
  const history = useHistory();

  const goToGenerator = () => history.push("/generators");
  return (
    <>
      <Navbar />
      <Content>
        <Sidebar>
          <SidebarTitle>Content Templates</SidebarTitle>
          <SidebarContentContainer>
            {generators.map((template, key) => (
              <SidebarContentSubtitle key={key}>
                {template}
              </SidebarContentSubtitle>
            ))}
          </SidebarContentContainer>
        </Sidebar>
        <Rightbar>
          <GeneratorContent>
            <NewCard onClick={goToGenerator} />
            <ItemCard />
          </GeneratorContent>
        </Rightbar>
      </Content>
    </>
  );
};
export default Templates;
